<template>
    <rkm-area
        title="Prioridades"
        type="fieldset"
    >
        <template slot="trailing">
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                small
                title="Adicionar"
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List
            :data="data"
            :sla="sla"
        />

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>

// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true },
        sla: { type: [Array, Object], required: true },
    }
}
</script>